import { useSelector } from "react-redux";
import { KEY } from "./reducer";

export const getState = (state) => state[KEY] || [];

export const getSportComplex = (state) => getState(state).sportComplex || {};

export const getSportComplexSelector = () =>
    useSelector((state) => getSportComplex(state));